angular.module('impactx.themeconfigurator').directive('ixThemeConfiguratorColorPicker', function () {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            label: '@',
            colorValue: '=',
            workspaceName: '@'
        },
        controller: 'ThemeConfiguratorColorPickerCtrl',
        controllerAs: 'themeConfiguratorColorPickerCtrl',
        templateUrl: 'modules/themeconfigurator/templates/theme-configurator-color-picker.html',
        link: function (scope, element, attrs, ctrl) {
            ctrl.x = 0;
            ctrl.y = 0;
            ctrl.sliderValue = 0;
            ctrl.drag = false;
            ctrl.rgbaColor = 'rgba(255,0,0,1)';
            ctrl.subElement = element.find('div.md-thumb')[0];
            ctrl.colorLabel = angular.element('.ix-main-toolbar')[0];
            ctrl.colorLabel2 = element.find('.color-picker-header')[0];
            ctrl.textHeader = element.find('.color-picker-header-text')[0];
            ctrl.colorBlock = element.find('.color-picker-main-canvas')[0];
            ctrl.mainCanvas = ctrl.colorBlock.getContext('2d');
            ctrl.width = ctrl.colorBlock.width;
            ctrl.height = ctrl.colorBlock.height;
            ctrl.mainCanvas.rect(0, 0, ctrl.width, ctrl.height);
            ctrl.colorStrip = element.find('.side-canvas')[0];
            ctrl.sideCanvas = ctrl.colorStrip.getContext('2d');
            ctrl.width2 = ctrl.colorStrip.width;
            ctrl.height2 = ctrl.colorStrip.height;
            ctrl.cursor = element.find('.color-picker-cursor')[0];

            ctrl.fillGradient();

            ctrl.sideCanvas.rect(0, 0, ctrl.width2, ctrl.height2);
            var grd1 = ctrl.sideCanvas.createLinearGradient(0, 0, 0, ctrl.height);
            grd1.addColorStop(0, 'rgba(255, 0, 0, 1)');
            grd1.addColorStop(0.17, 'rgba(255, 255, 0, 1)');
            grd1.addColorStop(0.34, 'rgba(0, 255, 0, 1)');
            grd1.addColorStop(0.51, 'rgba(0, 255, 255, 1)');
            grd1.addColorStop(0.68, 'rgba(0, 0, 255, 1)');
            grd1.addColorStop(0.85, 'rgba(255, 0, 255, 1)');
            grd1.addColorStop(1, 'rgba(255, 0, 0, 1)');
            ctrl.sideCanvas.fillStyle = grd1;
            ctrl.sideCanvas.fill();

            function mousedown(e) {
                ctrl.drag = true;
                ctrl.changeColor(e);
            }

            function mousemove(e) {
                if (ctrl.drag) {
                    ctrl.changeColor(e);
                }
            }

            function mouseup(e) {
                ctrl.drag = false;
            }

            ctrl.colorBlock.addEventListener("mousedown", mousedown, false);
            ctrl.colorBlock.addEventListener("mouseup", mouseup, false);
            ctrl.colorBlock.addEventListener("mousemove", mousemove, false);

            var colorValueWatcher = scope.$watch(function () {
                return ctrl.colorValue;
            }, function (newValue) {
                if (newValue) {
                    ctrl.hex = newValue;
                    ctrl.setColorValueByHex(ctrl.hex);
                    colorValueWatcher();
                }
            });
        }
    }
});